import { gql } from 'apollo-angular';

// Every operation in this file hits UsersResolver, which the Phase 1 RBAC
// backend plan gates admin-only (method-level) except findOne() — every
// login, not just admins', loads the current user through UserFindOne. The
// backend's UsersService.create/findAll/findOne/update all `include` roles.
// role, so selecting `roles` on mutation results returns real data.

export const GET_USERS = gql`
  query UserFindAll(
    $skip: Int
    $take: Int
    $orderBy: [UserOrderByWithRelationAndSearchRelevanceInput!]
    $where: UserWhereInput
  ) {
    UserFindAll(skip: $skip, take: $take, orderBy: $orderBy, where: $where) {
      id
      username
      nome
      email
      isActive
      roles {
        roleId
        role {
          id
          name
        }
      }
    }
  }
`;

export const GET_USER = gql`
  query UserFindOne($where: UserWhereUniqueInput!) {
    UserFindOne(where: $where) {
      id
      username
      nome
      email
      isActive
      createdAt
      updatedAt
      roles {
        roleId
        role {
          id
          name
        }
      }
    }
  }
`;

// `active` is a top-level argument (added by the backend Phase 1 plan),
// NOT a field of UserCreateInput — isActive is @HideField on the input.
export const CREATE_USER = gql`
  mutation UserCreate($data: UserCreateInput!, $active: Boolean) {
    UserCreate(data: $data, active: $active) {
      id
      username
      nome
      email
      isActive
      createdAt
      updatedAt
      roles {
        roleId
        role {
          id
          name
        }
      }
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UserUpdate(
    $data: UserUpdateInput!
    $where: UserWhereUniqueInput!
  ) {
    UserUpdate(data: $data, where: $where) {
      id
      username
      nome
      email
      isActive
      createdAt
      updatedAt
      roles {
        roleId
        role {
          id
          name
        }
      }
    }
  }
`;

// Only scalars are selected: the backend's remove() does not include
// relations on the deleted row.
export const DELETE_USER = gql`
  mutation UserDelete($where: UserWhereUniqueInput!) {
    UserDelete(where: $where) {
      id
      username
    }
  }
`;

export const ADD_USER_ROLE = gql`
  mutation UserAddRole($userId: Int!, $roleId: Int!) {
    UserAddRole(userId: $userId, roleId: $roleId) {
      id
      roles {
        roleId
        role {
          id
          name
        }
      }
    }
  }
`;

export const REMOVE_USER_ROLE = gql`
  mutation UserRemoveRole($userId: Int!, $roleId: Int!) {
    UserRemoveRole(userId: $userId, roleId: $roleId) {
      id
      roles {
        roleId
        role {
          id
          name
        }
      }
    }
  }
`;
